// extracted by mini-css-extract-plugin
export default {"headingColor":"ErrorBoundary__headingColor__UubWU"};
    if(module.hot) {
      // 1763020726968
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  